import { render, staticRenderFns } from "./ThreeCardsText.vue?vue&type=template&id=27c5373c"
import script from "./ThreeCardsText.vue?vue&type=script&lang=js"
export * from "./ThreeCardsText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports